module.exports = __webpack_public_path__ + "modules/bbs/img/68.gif";